import defaultUrl from './api';
const urls = {
    // 登录
    login: 'api/admin/login',
    // 验证码
    captcha: 'api/config/captcha',
    // 退出登录
    logout: 'api/admin/logout',
    // 左侧菜单
    menuList: 'api/menu/index',
    // 栏目列表
    columnList: 'api/column/index',
    // 新增栏目
    columnAdd: 'api/column/store',
    // 删除栏目
    columnDelete: 'api/column/destroy',
    // 栏目详情
    columnDetail: 'api/column/show',
    // 修改栏目
    columnEdit: 'api/column/update',
    // 栏目排序
    columnSort: 'api/column/move',
    // 栏目剪切
    columnCut: 'api/column/cut',
    // 栏目复制
    columnCopy: 'api/column/copy',
    // 栏目授权
    columnPermission: 'api/column/permission',
    // 设置微信公众号配置
    setMpWeixin: 'api/column/mpset',
    // 栏目推荐到首页
    columnRecommend: 'api/column/shareindex',
    // 角色列表
    roleList: 'api/roles/index',
    // 添加角色
    roleAdd: 'api/roles/store',
    // 修改角色
    roleEdit: 'api/roles/update',
    // 删除角色
    roleDelete: 'api/roles/destroy',
    // 角色排序
    roleSort: 'api/roles/move',
    // 角色授权
    rolePermission: 'api/roles/permission',
    // 权限列表
    permissionList: 'api/permission/index',
    // 管理员列表
    adminList: 'api/admin/index',
    // 抓取-栏目列表
    grabColumnList: 'api/column/getlist',
    // 抓取-栏目脚本列表
    grabList: 'api/grab/index',
    // 抓取-添加抓取脚本
    grabAdd: 'api/grab/store',
    // 抓取-编辑抓取脚本
    // grabEdit: 'api/grab/update',
    grabEdit: 'api/grab/selectupdate',
    // 设置栏目抓取时间
    setGrabTime: 'api/column/grabtime',
    // 抓取-查看脚本
    grabDetail: 'api/grab/show',
    // 抓取-删除抓取脚本
    grabDelete: 'api/grab/destroy',
    // 抓取-测试脚本
    grabTest: 'api/grab/check',
    // 抓取-文章列表
    grabArticleList: 'api/grab/articles',
    // 立即抓取
    nowGrab: 'api/grab/now',
    // 抓取发布-添加发布位置
    addRelease: 'api/column/addrelease',
    // 原创设置-推送
    originalPush: 'api/articles/othercolumnpush',
    // 原创设置-推送列表
    originalPushList: 'api/articles/articlepositionlist',
    // 原创审核-文章列表
    originalAuditList: 'api/articles/examinelist',
    // 原创审核-文章列表-文章详情
    originalAuditDetail: 'api/articles/examinedetail',
    // 原创审核-提交审核
    originalAuditCommit: 'api/articles/examine',
    // 文章列表
    articleList: 'api/articles/index',
    // 文章详情
    articleDetail: 'api/articles/show',
    // 添加文章
    articleAdd: 'api/articles/store',
    // 编辑文章
    articleEdit: 'api/articles/update',
    // 删除文章
    articleDelete: 'api/articles/destroy',
    // 文章图片本地化
    imagesLocal: 'api/articles/imageslocal',
    // 发布管理-文章列表
    publishArticleList: 'api/publish/getpublisharticles',
    // 发布管理-文章列表-立即发布
    nowIssue: 'api/publish/articlepush',
    // 发布管理-文章列表-批量发布
    batchPublish: 'api/publish/onlinecolumnpush',
    // 发布管理-文章列表-发布列表
    articleIssueList: 'api/publish/publishlist',
    // 发布管理-文章列表-点亮广告图标
    articleChangeAdvIcon: 'api/articles/isadvertisement',
    // 发布管理-线上文章列表
    onlineArticleList: 'api/articles/onlinepublisharticles',
    // 栏目文章推送至别的栏目
    colToOtherCol: 'api/publish/othercolumnpush',
    // 推送文章到公众号列表
    pushWxArticleList: 'api/publish/publishwx',
    // 公众号文章列表
    wxArticlelist: 'api/publish/getwxlist',
    // 公众号文章排序
    wxArticleSort: 'api/publish/wxsort',
    // 公众号文章-推送至媒体库
    wxArticleIssueToMedia: 'api/publish/synchronizationmedia',
    // 公众号文章-立即发布
    wxArticleNowIssue: 'api/publish/synchronizationwx',
    // 文章管理-标签管理-标签分类列表
    labelTypeList: 'api/labels/catelist',
    // 文章管理-标签管理-标签分类列表-添加标签分类
    labelTypeAdd: 'api/labels/addcate',
    // 文章管理-标签管理-标签分类列表-编辑标签分类
    labelTypeEdit: 'api/labels/editcate',
    // 文章管理-标签管理-标签分类列表-删除标签分类
    labelTypeDelete: 'api/labels/delcate',
    // 文章管理-标签管理-标签列表
    labelList: 'api/labels/index',
    // 文章管理-标签管理-标签列表(无分页)
    articleTags: 'api/labels/articlelabellist',
    // 文章管理-标签管理-添加标签
    labelAdd: 'api/labels/add',
    // 文章管理-标签管理-添加标签
    labelEdit: 'api/labels/edit',
    // 文章管理-标签管理-删除标签
    labelDelete: 'api/labels/delete',
    // 文章管理-标签管理-标签分组（批量操作）
    labelGroup: 'api/labels/labelgroup',
    // 文章管理-标签管理-标签列表-是否启用标签
    labelOpen: 'api/labels/isuse',
    // 文章推荐-广告位列表
    advPositionList: 'api/advertisementposition/index',
    // 文章推荐-添加广告位
    advPositionAdd: 'api/advertisementposition/advertisementset',
    // 文章推荐-编辑广告位
    advPositionEdit: 'api/advertisementposition/editadvertisement',
    // 文章推荐-删除广告位
    advPositionDelete: 'api/advertisementposition/delete',
    // 文章推荐-广告位列表-是否开放
    advPositionOpen: 'api/advertisementposition/isopen',
    // 文章推荐-广告位列表-文章列表
    advertisingArticles: 'api/advertisementposition/articlelist',
    // 文章推荐-广告位列表-文章列表-已发布文章列表
    advertisingOnlineArticles: 'api/advertisementposition/onlinearticles',
    // 文章推荐-广告位列表-文章列表-添加广告文章
    advertisingArticlesAdd: 'api/advertisementposition/add',
    // 文章推荐-广告位列表-文章列表-文章置顶
    advArticleTop: 'api/advertisementposition/istop',
    // 文章推荐-广告位列表-文章列表-文章显示
    advArticleShow: 'api/advertisementposition/isshow',
    // 文章推荐-广告位列表-文章列表-文章删除
    advArticleDelete: 'api/advertisementposition/deletearticle',
    // 授权管理-授权申请-申请列表
    accreditApplyList: 'api/jurisdiction/index',
    // 授权管理-授权申请-申请列表-删除
    accreditApplyDelete: 'api/jurisdiction/delete',
    // 授权管理-授权申请-提交审核
    accreditApplyDetail: 'api/jurisdiction/show',
    // 授权管理-授权申请-提交审核
    accreditApplyCheck: 'api/jurisdiction/check',
    // 授权管理-系统授权
    systemAccreditList: 'api/systemauthor/index',
    // 授权管理-系统授权-更改角色
    systemAccreditChange: 'api/systemauthor/changerole',
    // 授权管理-系统授权-撤销授权
    systemAccreditCancel: 'api/systemauthor/cancel',
    // 授权管理-系统授权-重新授权
    systemAccreditReset: 'api/systemauthor/reset',
    // 授权管理-系统授权-删除
    systemAccreditDelete: 'api/systemauthor/delete',
    // 授权管理-授权列表
    accreditList: 'api/systemauthor/alllist',
    // 授权管理-授权列表-会员列表
    accreditMenberList: 'api/systemauthor/userlist',
    // 公众号托管-托管审核-审核列表
    mpwxTrusteeshipAuditList: 'api/officialaccountadmin/index',
    // 公众号托管-托管审核-审核列表-删除审核
    mpwxTrusteeshipAuditDelete: 'api/officialaccountadmin/delete',
    // 公众号托管-托管审核-审核详情
    mpwxTrusteeshipAuditDetail: 'api/officialaccountadmin/show',
    // 公众号托管-托管审核-提交审核
    mpwxTrusteeshipAuditCheck: 'api/officialaccountadmin/check',
    // 公众号托管-添加托管
    mpwxTrusteeshipAuditAdd: 'api/officialaccountadmin/apply',
    // 公众号托管-托管列表-推荐到一级
    mpwxRecommendFirst: 'api/officialaccountadmin/recommend',
    // 公众号托管-托管列表-文章列表
    mpwxArticleList: 'api/officialaccountadmin/getarticles',
    // 公众号托管-托管列表-文章列表-添加文章
    mpwxArticleAdd: 'api/officialaccountadmin/addarticles',
    // 公众号托管-托管列表-文章列表-添加文章
    mpwxArticleDelete: 'api/officialaccountadmin/deletearticles',
    // 公众号托管-托管列表-文章列表-发布文章
    mpwxArticlePublish: 'api/officialaccountadmin/publish',
    // 会员管理-湾潮会员-会员列表
    baytrendMenberList: 'api/webuser/index',
    // 会员管理-湾潮会员-会员列表-会员详情
    baytrendMenberDetail: 'api/webuser/show',
    // 会员管理-湾潮会员-会员列表-发表文章列表
    bmPublishArticleList: 'api/webuser/publisharticles',
    // 会员管理-湾潮会员-会员列表-转发文章列表
    bmForwardArticleList: 'api/webuser/forwardarticles',
    // 会员管理-湾潮会员-会员列表-转发文章列表-一级转发列表
    bmForwardOneList: 'api/webuser/onearticles',
    // 会员管理-湾潮会员-会员列表-转发文章列表-二级转发列表
    bmForwardTwoList: 'api/webuser/secondarticles',
    // 会员管理-湾潮会员-会员列表-粉丝列表
    baytrendMenberFansList: 'api/webuser/fans',
    // 会员管理-湾潮会员-会员列表-关注公众号列表
    bmFollowcolumnList: 'api/webuser/followcolumn',
    // 会员管理-湾潮会员-会员列表-关注作者列表
    bmFollowList: 'api/webuser/follows',
    // 会员管理-湾潮会员-会员列表-收藏列表
    bmCollectionList: 'api/webuser/collection',
    // 会员管理-湾潮会员-会员列表-佣金列表
    bmCommissionList: 'api/webuser/commission',
    // 会员管理-小程序会员-会员列表
    appletMenberList: 'api/webuser/appletsusers',
    // 会员管理-小程序会员-会员详情
    appletMenberDetail: 'api/webuser/userinfo',
    // 会员管理-小程序会员-会员详情-订单列表
    appletOrderList: 'api/webuser/orders',
    // 会员管理-小程序会员-会员详情-分销转发列表
    appletForwardList: 'api/webuser/distributionforwarding',
    // 会员管理-小程序会员-会员详情-分销佣金列表
    appletCommisstionList: 'api/webuser/distributioncommission',
    // 第三方数据接口（商品。商户。）
    otherCurlapi: 'api/advertisement/curlapi',
    // 商品列表
    goodsList: 'api/store/goodslist',
    // 商品分类
    cateGoodsList: 'api/advertisement/categoodslist',
    // 商品分类-卓悦汇
    zyhCateGoodsList: 'api/advertisement/zhuoyuecategoodslist',
    // 新增商品分类
    addGoodsType: 'api/advertisement/categoods',
    // 新增商品分类-卓悦汇
    zyhAddGoodsType: 'api/advertisement/zhuoyuecategoods',
    // 修改商品分类
    editGoodsType: 'api/advertisement/categoodsedit',
    // 修改商品分类-卓悦汇
    zyhEditGoodsType: 'api/advertisement/zhuoyuecategoodsedit',
    // 商品分类详情
    goodsTypeDetail: 'api/advertisement/categoodsdetail',
    // 商品分类详情-卓悦汇
    zyhGoodsTypeDetail: 'api/advertisement/zhuoyuecategoodsdetail',
    // 删除商品分类
    deleteGoodsType: 'api/advertisement/categoodsdel',
    // 删除商品分类-卓悦汇
    zyhDeleteGoodsType: 'api/advertisement/zhuoyuecategoodsdel',
    // 商家商品列表-卓悦汇
    zyhStoreGoodsList: 'api/advertisement/zhuoyuestoregoods',
    // 设置爆款促销-卓悦汇
    zyhSetPromotion: 'api/advertisement/zhuoyuesetpromotion',
    // 设置到店巨惠-卓悦汇
    zyhSetOnsite: 'api/advertisement/zhuoyuesetonsite',
    // 获取分类商品-卓悦汇
    zyhTypeGoodsList: 'api/store/getcategoods',
    // 商品二维码
    goodsQrcode: 'api/advertisement/goods_qrcode',
    // 店铺二维码
    storeQrcode: 'api/advertisement/store_qrcode',
    // 商品详情
    goodsDetail: 'api/advertisement/goodsdetail',
    // 商家列表
    storeList: 'api/store/storelist',
    // 商家详情
    shopDetail: 'api/advertisement/storedetail',
    // 楼层导航列表
    levelList: 'api/store/floors',
    // 楼层商家列表
    floorShopList: 'api/store/floorstores',
    // 添加楼层
    addFloor: 'api/advertisement/addfloor',
    // 编辑商家楼层
    editShopFloor: 'api/advertisement/setfloor',
    // 编辑商家楼层-卓悦汇
    zyhEditShopFloor: 'api/store/zhuoyuesetfloor',
    // 小程序-商品列表-卓悦汇
    zyhGoodsList: 'api/store/zhuoyuegoodslist',
    // 小程序-楼层导航列表-卓悦汇
    zyhFloorList: 'api/store/zhuoyuefloors',
    // 小程序-楼层商家列表-卓悦汇
    zyhLevelShopList: 'api/store/zhuoyuefloorstores',
    // 小程序-爆款促销列表-卓悦汇
    zyhHotPromotionList: 'api/advertisement/zhuoyuepromotionstoregoods',
    // 小程序-到店巨惠列表-卓悦汇
    zyhOnsiteList: 'api/advertisement/zhuoyueonsitestoregoods',
    // 小程序-商品列表-米链优选
    mlyxGoodsList: 'api/store/miliangoodslist',
    // 提现审核列表
    withdrawalAuditList: 'api/withdrawal/index',
    // 提现审核详情
    withdrawalAuditDetail: 'api/withdrawal/detail',
    // OA提现审核
    oaWithdrawalAudit: 'api/withdrawal/check',
    // 财务提现审核
    financeWithdrawalAudit: 'api/withdrawal/paymenthandle',
    // 设置角色支付密码
    setPayPassword: 'api/roles/setpaypwd',
    // 单图片上传
    configImage: 'api/config/image',
    // 多图片上传
    configImages: 'api/config/images',
    // 文档文件上传
    configOffice: 'api/config/office',
    // 视频上传
    configVideo: 'api/config/video',
    // 获取上传token
    getUpToken: 'api/config/qiniutoken',
    // 清除缓存
    clearCache: 'api/config/flushcache'
};
Object.keys(urls).forEach(el => {
    urls[el] = defaultUrl + urls[el];
});
export default urls;


// WEBPACK FOOTER //
// ./src/ws/apiUrl.js